import React from 'react';
import useScript from 'react-script-hook';
// import GenericCard from '../Resources/credit-card.svg';

export const Payment = props => {

    const [cardNo, setCardNo] = React.useState('●●●● ●●●● ●●●● ●●●●');
    const [cardNoInput, setCardNoInput] = React.useState('');
    // const [cardNoEncrypt, setCardNoEncrypt] = React.useState('');

    const [cardName, setCardName] = React.useState('FULL NAME');
    const [cardNameInput, setCardNameInput] = React.useState('');

    const [cardMonth, setCardMonth] = React.useState('MM');
    const [cardMonthInput, setCardMonthInput] = React.useState('');

    const [cardYear, setCardYear] = React.useState('YY');
    const [cardYearInput, setCardYearInput] = React.useState('');

    const [cardCVC, setCardCVC] = React.useState('●●●');
    const [cardCVCInput, setCardCVCInput] = React.useState('');
    // const [cardCVCEncrypt, setCardCVCEncrypt] = React.useState('');

    const [renewLength, setRenewLength] = React.useState('');
    const [renewOne, setRenewOne] = React.useState(false);
    const [renewThree, setRenewThree] = React.useState(false);
    const [renewFive, setRenewFive] = React.useState(false);

    const [rotateCard, setRotateCard] = React.useState({transform: 'rotateY(0deg)'});
    const [cardType, setCardType] = React.useState('');
    const [hideType, setHideType] = React.useState(true);

    const [notSignUp, setNotSignUp] = React.useState(true);
    const [venue, setVenue] = React.useState('');

    const [showVoucher, setShowVoucher] = React.useState(false);


    const [loading] = useScript({ src: 'https://secure.ewaypayments.com/scripts/eCrypt.js' });
    //Sandbox key
    // const key = "rTtjHqzhFTiVw9c2UvViCNhsdbex5JR6jrvbm+dTjPuxqlPC25iHT4gqtciMvVA2MF3/j2Kabne9S3ePZJW3DPzJ5m8P96Qh56HPEnKR4eV4V9APBDuiwyOJtUYRj1SdEh7YrWd5oknabvMMemd7jEh9QvsnE0hGTh4DKLaOJYaJKyZ2ccW0XEBdwGTKR7D4i+38auDC9ItXUz59xNJVt9/AuvsMqmkY0vQN7fznoni+ZMDd6+Rw7P+/FzdB/B9uPCsV4pxux+Blu8LroSkz91BfNbEa6QKB+yolj/wZNoUbSDZjQ9I7Imy18nb0GTn1PWsvG6fpVmFses3v9SRtjw==";
    //Live Key
    const key = "q0rhfV/wpoXlDqbgt1kQw5n8hV+pMeEjkbPPmGQWJWI15d48z8vbuhdvdz8pXIvXWsyvjOpIQ/WwlNBDYIrC9otysdVhCSqVyQMpvw3WLUGykApUfe0cXCH5axrHy7dlgVq/LTFWmYytVqt0Izhz4XIim8bahTtuvbz2go0p5fCRFiMCYHz7kzEcJRj7yHG0nBdiBdxS9Ox9S1a2Kgy8IttfEehZ8AEaOMUUzU8p21vQgUUJDCUVxUa8xkgqnLSw20ZpZSMbroW0KP1ropN3gn+eV2MJgWjDPXzK0SOBWQRjW04xY3sihn94GswtHOEbosK6paJk+FaePQKIAtJfMQ==";

    React.useEffect(()=>{
        if('parentIFrame' in window){
            window.parentIFrame.scrollTo(0, 0);
        }

        if(window.location.pathname === '/renew'){
            setShowVoucher(true);
        }

        // console.log(props.isEdited);
        // console.log(props.paymentData);
        if(window.location.pathname.includes('signup')){
            setNotSignUp(false);
            setVenue(props.paymentData.venue);
        }
        if(props.isEdited){
            setCardNameInput(props.paymentData.name);
            setCardMonthInput(props.paymentData.expiryMonth);
            setCardYearInput(props.paymentData.expiryYear);
            setCardCVCInput(props.paymentData.cvn);
            setCardNoInput(props.paymentData.number);

            setCardType(props.paymentData.type);

            setCardName(props.paymentData.name);
            setCardMonth(props.paymentData.expiryMonth);
            setCardYear(props.paymentData.expiryYear);
            setCardCVC(props.paymentData.cvn);
            setCardNo(props.paymentData.number);
            setRenewLength(props.paymentData.length);
            
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //Whenever a change is detected, it will run formChange which will save the data into the renew page
    React.useEffect(() =>{
        // console.log("RUNNING");
        //Encrypts the card details before being sent off to eWay to process payment
        //Note that the current key is set to the sandbox key
        // if(cardNoInput){
        //     console.log("Card Number Encrypted");
        //     setCardNoEncrypt(window.eCrypt.encryptValue(cardNoInput.replace(/\s/g, ''), key));
        // }
        // if(cardCVCInput){
        //     console.log("CVC Encrypted");
        //     setCardCVCEncrypt(window.eCrypt.encryptValue(cardCVCInput, key));
        // }

        formChange();

        // console.log(renewLength);
        switch(renewLength){
            case 1:
                // console.log("CASE 1");
                setRenewOne(true);
                setRenewThree(false);
                setRenewFive(false);
                break;
            case 3:
                // console.log("CASE 2");
                setRenewOne(false);
                setRenewThree(true);
                setRenewFive(false);
                break;
            case 5:
                setRenewOne(false);
                setRenewThree(false);
                setRenewFive(true);
                // console.log("CASE 3");
                break;
            default:
                break;
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cardNo, cardName, cardMonth, cardYear, cardCVC, renewLength, venue]);

    const formChange = () =>{
        if(!loading){
        // console.log("form change");
        var formDetails = {
            name: cardNameInput,
            number: cardNoInput,
            expiryMonth: cardMonthInput,
            expiryYear: cardYearInput,
            cvn: cardCVCInput,
            length: renewLength,
            type: cardType,
            // noEncrypt: window.eCrypt.encryptValue(cardNoInput.replace(/\s/g, ''), key),
            // cvcEncrypt: window.eCrypt.encryptValue(cardCVCInput, key)
            // noEncrypt: cardNoEncrypt,
            // cvcEncrypt: cardCVCEncrypt
        }
        if(cardNoInput){
            formDetails.noEncrypt = window.eCrypt.encryptValue(cardNoInput.replace(/\s/g, ''), key);
        }
        if(cardCVCInput){
            formDetails.cvcEncrypt = window.eCrypt.encryptValue(cardCVCInput, key);
        }
        if(!notSignUp){
            formDetails.venue = venue;
        }
        props.savePayment(formDetails);
    }
    }

    //Rotates the card when the user focuses on the CVC textfield
    const focusCVC = () =>{
        setRotateCard({transform: 'rotateY(180deg)'});
    }
    const outFocusCVC = () =>{
        setRotateCard({transform: 'rotateY(0deg)'});
    }

    const outFocusMonth = (ev) =>{
        if(ev.target.value.length === 1){
            setCardMonth(ev.target.value.replace(/^/,'0'));
            setCardMonthInput(ev.target.value.replace(/^/,'0'));
        }
    }

    const cardCVCChange = (ev) =>{
        if(ev.target.value.length === 0){
            setCardCVC('●●●');
            setCardCVCInput('');
            return;
        }
        if(ev.target.value.length === 4){
            return;
        }
        setCardCVC(ev.target.value);
        setCardCVCInput(ev.target.value);
    }

    const cardYearChange = (ev) =>{
        if(ev.target.value.length === 0){
            setCardYear('YY');
            setCardYearInput('');
            return;
        }
        if(ev.target.value.length === 3){
            return;
        }
        setCardYear(ev.target.value);
        setCardYearInput(ev.target.value);
    }

    const cardMonthChange = (ev) =>{
        if(ev.target.value.length === 0){
            setCardMonth('MM');
            setCardMonthInput('');
            return;
        }
        //Limits the user input to 2 digits max
        if(ev.target.value.length === 3){
            return;
        }
        //Prevents the user from entering a value that is greater than 12
        if(ev.target.value > 12){
            return;
        }
        setCardMonth(ev.target.value);
        setCardMonthInput(ev.target.value);
    }

    const cardNameChange = (ev) =>{
        if(ev.target.value){
            setCardName(ev.target.value);
            setCardNameInput(ev.target.value);
        } else {
            setCardName('FULL NAME');
            setCardNameInput('');
        }
    }

    //Sets the card number to render on the card
    const cardNoChange = (ev) =>{
        //If the input is empty, then set the values
        if(!ev.target.value){
            setCardNo('●●●● ●●●● ●●●● ●●●●');
            setCardNoInput('');
            return;
        }

        //Sets the card type image
        if(ev.target.value.length === 4){
            var check = ev.target.value.substring(0, 2);
            var first = check.substring(0, 1);
            var second = check.substring(1);
            var dankort = ev.target.value.substring(0, 4);
            if(dankort === '5019'){
                setCardType('https://upload.wikimedia.org/wikipedia/commons/5/51/Dankort_logo.png');
                setHideType(false);
            } else if(first === '4'){
                setCardType('https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Visa_Inc._logo.svg/2000px-Visa_Inc._logo.svg.png');
                setHideType(false);
            } else if(first === '5'){
                setCardType('https://upload.wikimedia.org/wikipedia/commons/0/04/Mastercard-logo.png');
                setHideType(false);
            } else if(first === '3' && (second === '4' || second === '7')){
                setCardType('https://upload.wikimedia.org/wikipedia/commons/thumb/3/30/American_Express_logo.svg/600px-American_Express_logo.svg.png');
                setHideType(false);
            } else if(first === '6'){
                setCardType('https://lendedu.com/wp-content/uploads/2016/03/discover-it-for-students-credit-card.jpg');
                setHideType(false);
            } else if(first === '3' && (second === '0' || second === '6' || second === '8')){
                setCardType('https://upload.wikimedia.org/wikipedia/commons/thumb/a/a6/Diners_Club_Logo3.svg/1920px-Diners_Club_Logo3.svg.png');
                setHideType(false);
            } else {
                setHideType(true);
            }
        }

        var val = ev.target.value;
        const valArray = val.split(' ').join('').split('');
        var valSpace = val.split("");

        if(valSpace[valSpace.length-1] === ' '){
            var valSpaceN = valSpace.slice(0, -1);
            val = valSpaceN.join("");
            setCardNo(val);
            setCardNoInput(val);
            return;
        }

        if(isNaN(valArray.join('')))
            return;
        if(valArray.length === 17)
            return;
        if(valArray.length % 4 === 0 && valArray.length <= 15) {
            setCardNo(ev.target.value + " ");
            setCardNoInput(ev.target.value + " ");
        }else{
            setCardNo(ev.target.value);
            setCardNoInput(ev.target.value);
        }
    }

    return(
        <div>
        <div className="container">
            <h2 id="gtm-payment" className="text-center"><strong>Payment</strong></h2>
            <p className="text-center">Select your membership length and enter your payment details here</p>
            <div className="row">
                <div className="col-md-6">
                    <form>
                        <div className="paymentDIV">
                            <h3><strong>Membership Length</strong></h3>
                            <input className="subscriptionCB" type="radio" name="duration" value="1" id="1_year" onChange={()=> ""} checked={renewOne} onClick={()=> setRenewLength(1)} />
                            <label className="formLabel">1 Year - <strong>$5.00</strong></label>
                            <br/>
                            <input className="subscriptionCB" type="radio" name="duration" value="3" id="3_year" onChange={()=> ""} checked={renewThree} onClick={()=> setRenewLength(3)} />
                            <label className="formLabel">3 Years - <strong>$10.00</strong><span hidden={!showVoucher} className="bonus-offer-text"> (inc. $5 Voucher)</span></label>
                            <br/>
                            <input className="subscriptionCB" type="radio" name="duration" value="5" id="5_year" onChange={()=> ""} checked={renewFive} onClick={()=> setRenewLength(5)} />
                            <label className="formLabel">5 Years - <strong>$15.00</strong><span hidden={!showVoucher} className="bonus-offer-text"> (inc. $10 Voucher)</span></label>
                            <div hidden={notSignUp} >
                            <br/><br/>
                                <h3><strong>Preferred Venue</strong></h3>
                                <select className="formInput" value={venue} name="venue" onChange={(ev)=> setVenue(ev.currentTarget.value)}>
                                    <option value="" hidden>Please Select</option>
                                    <option value="1">Bankstown Sports</option>
                                    <option value="2">Baulkham Hills Sports</option>
                                    <option value="3">Birrong Sports</option>
                                    <option value="4">Bankstown Bowls</option>
                                    <option value="5">The Acres Club</option>
                                    <option value="6">Auburn Tennis Club</option>
                                </select>
                            </div>
                        </div>
                        
                        <div className="paymentDIV">
                            <h3><strong>Card Details</strong></h3>
                            <label className="formLabel">Card Number</label>
                            <br/>
                            <input className="formInput" id="cardNumber" autoComplete="cc-number" type="text" value={cardNoInput} onChange={cardNoChange}/>
                            <br/>

                            <label className="formLabel">Cardholder Name</label>
                            <br/>
                            <input className="formInput" id="cardHolder" autoComplete="cc-name" type="text" value={cardNameInput} onChange={cardNameChange}/>
                            <br/>

                            <label className="formLabel">Expiry Date</label>
                            <br/>
                            <div className="expiryDIV">
                                <input className="expiryInput" id="cardExpirationMonth" type="number" placeholder="MM" value={cardMonthInput} onChange={cardMonthChange} onBlur={outFocusMonth}/>
                                <span className="expiryDivider">/</span>
                                <input className="expiryInput" id="cardExpirationYear" type="number" placeholder="YY" value={cardYearInput} onChange={cardYearChange}/>
                            </div>

                            <br/>
                            <div className="cvcDIV">
                                <label className="formLabel">Security Number</label>
                                <input className="formInput" id="cardCsc" autoComplete="cc-csc" type="number" placeholder="CVC" onFocus={focusCVC} onBlur={outFocusCVC} onChange={cardCVCChange} value={cardCVCInput}/>
                            </div>
                        </div>
                    </form>
                </div>
                <div className="col-md-6">

                <div className="cardDIV">
                    <div className="card" style={rotateCard}>
                        <div className="front">
                            <div className="type">
                                <img className="bankid" hidden={hideType} src={cardType} alt="Card Type"/>
                            </div>
                            <span className="chip"></span>
                            <span className="card_number">{cardNo}</span>
                            <div className="date"><span className="date_value">{cardMonth} / {cardYear}</span></div>
                            <span className="fullname">{cardName}</span>
                        </div>
                        <div className="back">
                            <div className="magnetic"></div>
                            <div className="bar"></div>
                            <span className="seccode">{cardCVC}</span>
                            <span className="chip"></span><span className="disclaimer">This card is property of Random Bank of Random corporation. <br/> If found please return to Random Bank of Random corporation <br /> 8 Greenfield Parade, Bankstown, 2200 </span>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
        </div>
    )
}